import React from "react";
import { createStackNavigator } from "@react-navigation/stack";

import CurrentQEMIDetails from "../screens/Investment/CurrentQEMI/CurrentQemiDetails";

const Stack = createStackNavigator();

export const EMIStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen
        name="CurrentQEMIDetails"
        component={CurrentQEMIDetails}
        initialParams={{ source: "EMI" }}
      />
    </Stack.Navigator>
  );
};

export default EMIStackNavigator;
